import { IUser, useViewModel } from '@utils';
import { MeetingPlanerViewModel } from '@views';
import { observer } from 'mobx-react-lite';
import React, { useCallback, useRef, useState } from 'react';
import { Button } from '../button';
import { OccupiedTime } from '../occupiedTime';
import { PlannerPlus } from '../svgs/PlannerPlus';
import { Cols, Header, MemberList } from './components';
import { toast } from "react-toastify";

export const MeetingPlanerSchedule = observer(() => {
  const meetingPlanerViewModel = useViewModel(MeetingPlanerViewModel);

  const [isOpenMemberList, setIsOpenMemberList] = useState(false);

  const onClose = () => setIsOpenMemberList(false);
  const onToggleIsOpenMemberList = useCallback(() => setIsOpenMemberList(prev => !prev), [isOpenMemberList]);
  const findById = (id: number) => meetingPlanerViewModel.selectedMembers.has(id);
  const sortingRule = (a: IUser, b: IUser) => {
    if (findById(a.id) && !findById(b.id)) {
      return -1;
    }
    if (findById(b.id) && !findById(a.id)) {
      return 1;
    }
    if (a.fullName < b.fullName) {
      return -1;
    }
    if (a.fullName > b.fullName) {
      return 1;
    }
    return 0;
  };

  const handleMemberSelect = (memberId: number) => {
    if (findById(memberId) || meetingPlanerViewModel.selectedMembers.size < 10) {
      meetingPlanerViewModel.updateSelectedMembers(memberId);
    } else {
      toast.error('Нельзя добавить более 10 человек');
    }
  };

  const buttonRef = useRef<HTMLButtonElement>();

  return (
    <div className="calendar meeting-planer-schedule">
      <Header />
      {meetingPlanerViewModel.occupiedTime.map(({ start, end }, index) => (
        <OccupiedTime
          key={`occupied-time-${start.getTime()}-${index}`}
          start={start}
          end={end}
        />
      ))}
      <Cols members={meetingPlanerViewModel.membersValues.slice(0, 10)} />
      <div className="add-button-container">
        {!isOpenMemberList
          ? (
            <Button
              onClick={onToggleIsOpenMemberList}
              buttonRef={buttonRef}
              className="fixed-button add-button"
              icon={<PlannerPlus />}
            />
          )
          : (
            <MemberList
              onClose={onClose}
              className="fixed-list"
              sortingRule={sortingRule}
              topOfList={0}
              rightOfList={0}
              onMemberSelect={handleMemberSelect}
            />
          )
        }
      </div>
    </div>
  );
});
